define.alias("ember-cli-string-helpers/helpers/underscore", "media/helpers/underscore");